// extracted by mini-css-extract-plugin
export default {"link":"link__axO3M","logo":"logo__pHNJD"};